import { combineEpics } from 'redux-observable'
import { createInvokeEpic } from '../../signalr/createInvokeEpic'
import {
  fetchUserEditorDataDefinition,
  saveUserEditorDataDefinition
} from './definition'

export default combineEpics(
  createInvokeEpic(
    'userEditorData.fetchUserEditorData',
    fetchUserEditorDataDefinition
  ),
  createInvokeEpic(
    'userEditorData.saveUserEditorData',
    saveUserEditorDataDefinition
  )
)
